const OrderStatistics = () =>
  import(
    /* webpackChunkName: "reports-statistical" */ '@/pages/report/statistical/order.vue'
  )
const CourierOrdersStatistics = () =>
  import(
    /* webpackChunkName: "reports-statistical" */ '@/pages/report/statistical/courier-orders.vue'
  )
const UserStatistics = () =>
  import(
    /* webpackChunkName: "reports-statistical" */ '@/pages/report/statistical/user.vue'
  )
const CourierScoreStatistics = () =>
  import(
    /* webpackChunkName: "reports-statistical" */ '@/pages/report/statistical/courier-score.vue'
  )

export default {
  path: 'statistical',
  meta: {
    label: 'chart',
    auth: 'statistical'
  },
  component: {
    name: 'Statistical',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'ReportOrderStatistics',
      path: 'order',
      meta: {
        label: 'shipmentStatistics',
        auth: 'order'
      },
      component: OrderStatistics
    },
    {
      name: 'ReportCourierOrdersStatistics',
      path: 'courier-orders',
      meta: {
        label: 'companyShipmentStatistics',
        auth: 'courierOrder'
      },
      component: CourierOrdersStatistics
    },
    {
      name: 'ReportUserStatistics',
      path: 'user',
      meta: {
        label: 'userStatistics',
        auth: 'user'
      },
      component: UserStatistics
    },
    {
      name: 'ReportCourierScoreStatistics',
      path: 'courier-score',
      meta: {
        label: 'companyScoreStatistics',
        auth: 'courierScore'
      },
      component: CourierScoreStatistics
    }
  ]
}
